<template>
  <el-row>
    <el-col :span="24">
      <div class="head-wrap">
      </div>
    </el-col>

  </el-row>
</template>

<script>
export default {
  name: 'navHeader',

}
</script>

<style scoped>

</style>
